<template>
  <div>
    <Notification
      v-if="submitStatus.success || submitStatus.failureGeneric"
      class="large-12"
      :aria-hidden="!submitStatus.success || !submitStatus.failureGeneric"
      :severity="notificationType"
      aria-role="status"
      :closable="true"
      @close="cancelComment"
    >
      <div class="grid-x">
        {{ notificationMsg }}
      </div>
    </Notification>
    <Form
      v-if="!submitStatus.success && !submitStatus.failureGeneric"
      v-slot="{ meta }"
      class="grid-x align-start"
      aria-label="review comment form"
      :aria-hidden="!submitStatus.success"
    >
      <div class="cell grid-y large-12">
        <div class="cell">
          <TextArea
            v-model="commentText"
            name="Comment"
            label="Comment*"
            rule="reviewText"
          />
        </div>
        <div class="cell grix-y">
          <div class="grid-x">
            <div
              class="cell nickname-input"
              :class="{ 'small-6': isMcom }"
            >
              <InputText
                v-model="nickName"
                name="nickName"
                label="Nickname*"
                rule="reviewNickname"
              />
            </div>
            <div
              v-if="isMcom"
              class="cell email-input"
            >
              <InputText
                v-model="emailAddresss"
                name="email"
                label="Email address"
                rule="email"
              />
            </div>
          </div>
          <div class="grid-x grid-margin-x margin-top-s button-container">
            <div class="cell small-6 cancel">
              <button
                class="button secondary cell"
                type="button"
                aria-label="cancel comment"
                @click.prevent="cancelComment"
              >
                Cancel
              </button>
            </div>
            <div class="cell small-6">
              <button
                class="button primary cell"
                type="submit"
                aria-label="submit comment"
                :disabled="(meta.valid && isSubmitEnabled) ? false : true"
                @click.prevent="submitReviewComment"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        <div class="grid-x small-margin-top-xs medium-margin-top-s">
          <p
            class="cell"
            aria-label="disclaimer text"
          >
            {{ FORM_DISCLAIMER_MSG }}
          </p>
        </div>
      </div>
    </Form>
  </div>
</template>

<script setup>
import { watch } from 'vue';
import InputText from '@atomic-ui/inputText';
import TextArea from '@atomic-ui/textArea';
import Notification from '@atomic-ui/notification';
import Form from '@atomic-ui/form';
import { useBrand } from '@composables/useBrand';
import { useReviewComments } from '@modules/reviewComments/composables/useReviewComments';
import { FORM_DISCLAIMER_MSG } from '../constants';

const { isMcom } = useBrand();
const props = defineProps({
  review: {
    type: Object,
    required: true,
  },
});

const {
  commentText, nickName, emailAddresss, submitReviewComment,
  clearFormAndErrorValues, submitStatus, isSubmitEnabled,
  notificationMsg, notificationType,
} = useReviewComments(props.review);

const emit = defineEmits(['cancelComment']);

const cancelComment = () => {
  clearFormAndErrorValues();
  emit('cancelComment', false);
};

watch(() => props.review, cancelComment);

</script>

<style lang="scss" brand="mcom">
@import "~settingSCSS";
  .small-6 {
    &.nickname-input {
      @include padding-direction('right', map-get($spacer, 'xxs'))
    }
  }

  @include breakpoint(large up) {
    .small-6 {
      &.nickname-input {
        @include padding-direction('right', map-get($spacer, 'xs'))
      }
    }
  }
</style>
